/*
  Bookingkalender og trinformular i "Book en demo"-popup'en (snippets/mabala-book-demo.liquid).
  Trin 1: dato (eller "ingen bestemt dato"). Trin 2: opsummering + kontaktoplysninger.

  - Kun hverdage fra i morgen og frem kan vælges.
  - "Jeg har ikke en bestemt dato" skjuler kalenderen.
  - Ved afsendelse kræves enten en dato eller afkrydsningen. Valget skrives i det skjulte
    felt contact[Ønsket demodato] (kommer med i mailen), og kvitteringsteksten tilpasses.
  - Kører i capture-fasen før mabala-scriptets submit-handler, så en ugyldig formular stoppes.
*/
(function () {
  if (window.__dmsDemoCalendar) return;
  window.__dmsDemoCalendar = true;

  var WEEKDAYS = ["Ma", "Ti", "On", "To", "Fr", "Lø", "Sø"];
  var state = { view: null, selected: null };

  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function firstSelectable() {
    var d = startOfDay(new Date());
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d;
  }

  function isSelectable(d) {
    var day = d.getDay();
    return day !== 0 && day !== 6 && d >= firstSelectable();
  }

  function longDate(d) {
    return d.toLocaleDateString("da-DK", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  }

  function iso(d) {
    var m = String(d.getMonth() + 1).padStart(2, "0");
    var day = String(d.getDate()).padStart(2, "0");
    return d.getFullYear() + "-" + m + "-" + day;
  }

  function root() {
    return document.querySelector("[data-dms-demo-date]");
  }

  function render() {
    var r = root();
    if (!r) return;
    var cal = r.querySelector("[data-dms-calendar]");
    if (!state.view) {
      var f = firstSelectable();
      state.view = new Date(f.getFullYear(), f.getMonth(), 1);
    }
    var year = state.view.getFullYear();
    var month = state.view.getMonth();
    var first = new Date(year, month, 1);
    var offset = (first.getDay() + 6) % 7; // mandag = 0
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var minMonth = new Date(firstSelectable().getFullYear(), firstSelectable().getMonth(), 1);
    var canPrev = state.view > minMonth;

    var title = first.toLocaleDateString("da-DK", { month: "long", year: "numeric" });
    var html =
      '<div class="dms-calendar-head">' +
      '<button type="button" class="dms-calendar-nav" data-dms-cal-prev aria-label="Forrige måned"' + (canPrev ? "" : " disabled") + '>‹</button>' +
      '<span class="dms-calendar-title">' + title.charAt(0).toUpperCase() + title.slice(1) + "</span>" +
      '<button type="button" class="dms-calendar-nav" data-dms-cal-next aria-label="Næste måned">›</button>' +
      "</div>" +
      '<div class="dms-calendar-grid" role="grid">';
    WEEKDAYS.forEach(function (w) {
      html += '<span class="dms-calendar-weekday" aria-hidden="true">' + w + "</span>";
    });
    for (var i = 0; i < offset; i++) html += '<span class="dms-calendar-empty"></span>';
    for (var d = 1; d <= daysInMonth; d++) {
      var date = new Date(year, month, d);
      var ok = isSelectable(date);
      var sel = state.selected && iso(state.selected) === iso(date);
      html +=
        '<button type="button" class="dms-calendar-day' + (sel ? " is-selected" : "") + '" data-dms-cal-day="' + iso(date) + '"' +
        (ok ? "" : " disabled") +
        ' aria-pressed="' + (sel ? "true" : "false") + '" aria-label="' + longDate(date) + '">' + d + "</button>";
    }
    html += "</div>";
    cal.innerHTML = html;

    var chosen = r.querySelector("[data-dms-demo-chosen]");
    if (state.selected) {
      chosen.textContent = "Ønsket dato: " + longDate(state.selected);
      chosen.hidden = false;
    } else {
      chosen.hidden = true;
    }
  }

  function setNoDate(on) {
    var r = root();
    r.classList.toggle("is-nodate", on);
    if (on) state.selected = null;
    render();
  }

  function dateValid() {
    var r = root();
    var noDate = r.querySelector("[data-dms-demo-nodate]").checked;
    if (state.selected || noDate) return true;
    var error = r.querySelector("[data-dms-demo-error]");
    error.textContent = "Vælg en dato i kalenderen, eller marker at du ikke har en bestemt dato.";
    error.hidden = false;
    return false;
  }

  function showStep(n) {
    var modal = document.getElementById("demoModal");
    if (!modal) return;
    modal.querySelectorAll("[data-dms-step]").forEach(function (panel) {
      panel.hidden = panel.dataset.dmsStep !== String(n);
    });
    modal.querySelectorAll("[data-dms-step-indicator]").forEach(function (li) {
      var i = +li.dataset.dmsStepIndicator;
      li.classList.toggle("is-active", i === n);
      li.classList.toggle("is-done", i < n);
    });
    if (n === 2) {
      var summary = modal.querySelector("[data-dms-demo-summary-date]");
      if (summary) summary.textContent = state.selected ? longDate(state.selected) : "Ingen bestemt dato — vi kontakter dig";
      var first = modal.querySelector("#demo-name");
      if (first) setTimeout(function () { first.focus(); }, 50);
    }
    var body = modal.querySelector(".dms-modal-body");
    if (body) modal.scrollTop = 0;
  }

  document.addEventListener("click", function (event) {
    var r = root();
    if (event.target.closest && event.target.closest("[data-dms-step-next]")) {
      if (dateValid()) showStep(2);
      return;
    }
    if (event.target.closest && event.target.closest("[data-dms-step-back]")) {
      showStep(1);
      return;
    }
    if (!r || !r.contains(event.target)) {
      // Popup'en åbnes: start på trin 1 (efter en afsendelse nulstilles valget)
      if (event.target.closest && event.target.closest("#openDemoModal")) {
        var form = document.getElementById("demoForm");
        if (form && !form.querySelector("#demo-name").value) {
          state.selected = null;
          var nd = r && r.querySelector("[data-dms-demo-nodate]");
          if (nd) nd.checked = false;
          if (r) r.classList.remove("is-nodate");
        }
        setTimeout(function () { render(); showStep(1); }, 0);
      }
      return;
    }
    var day = event.target.closest("[data-dms-cal-day]");
    if (day && !day.disabled) {
      var p = day.dataset.dmsCalDay.split("-");
      state.selected = new Date(+p[0], +p[1] - 1, +p[2]);
      r.querySelector("[data-dms-demo-nodate]").checked = false;
      r.classList.remove("is-nodate");
      r.querySelector("[data-dms-demo-error]").hidden = true;
      render();
      return;
    }
    if (event.target.closest("[data-dms-cal-prev]")) {
      state.view = new Date(state.view.getFullYear(), state.view.getMonth() - 1, 1);
      render();
    } else if (event.target.closest("[data-dms-cal-next]")) {
      state.view = new Date(state.view.getFullYear(), state.view.getMonth() + 1, 1);
      render();
    }
  });

  document.addEventListener("change", function (event) {
    if (event.target.matches && event.target.matches("[data-dms-demo-nodate]")) {
      setNoDate(event.target.checked);
      root().querySelector("[data-dms-demo-error]").hidden = true;
    }
  });

  // Capture-fase: før mabala-book-demo's submit-handler
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.id !== "demoForm") return;
      var r = root();
      if (!r) return;
      var noDate = r.querySelector("[data-dms-demo-nodate]").checked;
      var error = r.querySelector("[data-dms-demo-error]");
      var value = r.querySelector("[data-dms-demo-value]");

      if (!dateValid()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showStep(1);
        return;
      }

      var title = document.querySelector("[data-dms-demo-success-title]");
      var text = document.querySelector("[data-dms-demo-success-text]");
      if (state.selected) {
        value.value = longDate(state.selected) + " (" + iso(state.selected) + ")";
        if (title) title.textContent = "Tak! Vi har modtaget din demo-booking.";
        if (text) text.textContent = "Ønsket dato: " + longDate(state.selected) + ". Vi vender tilbage med en endelig bekræftelse på datoen.";
      } else {
        value.value = "Ingen bestemt dato";
        if (title) title.textContent = "Tak! Vi har modtaget din demo-booking.";
        if (text) text.textContent = "Vi kontakter dig for at aftale en dato, der passer dig.";
      }
    },
    true,
  );
})();
